<template>
 <div class="content">


  <OrkLoader :loading="loading">
    <div class="content-wrapper">
      <h2 v-if="error && !content" class="error-msg">{{ $t('serviceUnavailable') }}</h2>
      <div v-else-if="content" class="delivery">
       <!-- <SfHeading :level="1"
                   :title="content.cms_title"
                   class="sf-heading--left">
        </SfHeading>-->
        <div class="content" v-html="content.cms_description"></div>

      </div>
    </div>
  </OrkLoader>
 </div>
</template>
<script>

import OrkLoader from "@/components/Ork/OrkLoader";

import Api from "@/api/Api";

export default {
  name: "OrkAddToCart",
  components: {
    OrkLoader,

  },

  props: {
    pageId: {
      type: [String, null],
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      content: null,
      error:false
    };
  },
  created() {
    this.getContent();
  },
  methods: {
    getContent() {
      if (this.pageId) {
        this.loading = true;
        Api.marketing.getContentPage(this.pageId)
            .then((data) => {
              this.content = data;
              Api.marketing.setSeo(data)
            })
            .catch((err) => {
              this.error = true;
            }).finally(this.loading = false)
      }
    },
  }
};
</script>
<style lang="scss">

.content{
  margin: var(--spacer-xl) 0;
}
.sf-add-to-cart {

  gap: var(--spacer-sm);
  flex-wrap: wrap;

  .sf-button {

    flex: none;
    margin: auto 0 0 0;
    @include for-mobile {
      flex: 1;
    }
  }

  .label {
    display: block;
    color: var(--c-primary);
    font-size: var(--h4-font-size);
    font-weight: var(--font-weight--bold);
    margin: var(--spacer-lg) 0 var(--spacer-xs) 0;
  }

  .sf-add-to-cart__select-quantity {
    margin-right: 0;
  }

  .sf-add-to-cart__select-container {
    margin-right: 0;
  }

  .sf-quantity-selector {
    --quantity-selector-font-size: var(--font-size--lg);
    --quantity-selector-background: white;
    border-bottom: 2px solid var(--_c-darkgray);

    ::v-deep {
      .sf-input input[type=number] {
        font-weight: bold !important;
      }
    }
  }

  .btn_container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;


    .add_button {
      --button-color: var(--c-secondary-variant);
      --button-font-size: var(--font-size--lg);
      font-weight: bold;
      background: white;
      height: fit-content;
      box-shadow: 0px 4px 10px 0px rgb(0 0 0 / 25%);
    }
  }
}

.addloader {
  background: none;
  width: 38px;

  .sf-loader__overlay {
    background: none;
  }
}
</style>
